import { FETCH_DIRECTORY_COMPANIES, FETCHED_DIRECTORY_COMPANIES, SELECT_DIRECTORY_COMPANY, SEARCH_DIRECTORY_COMPANIES, ANYWHERE_PARAM_COMPANY, START_WITH_PARAM, FETCH_DETAILS_FOR_SELECTED_COMPANY, FETCHED_DETAILS_FOR_SELECTED_COMPANY } from './DirectorySearchDataActions'


const directorySearchDataReducer = (state = { searchParameter: "", directoryCompanies: [], isFetching: false, isResultFetched: false, count: 0, currentPage: 0, searchAnywhereParam: "", startWithParam: "", isFetchingCompanyDetails: false, selectedCompanyDetails: null }, action) => {

    switch (action.type) {
        case FETCH_DIRECTORY_COMPANIES:
            return {
                ...state,
                isFetching: true,
                isResultFetched: false,
                currentPage: action.first ? 0 : (state.currentPage + 1),
                directoryCompanies: action.first ? [] : state.directoryCompanies,
                selectedCompanyDetails: null,
                activeLangCodeOfPages: action.first ? action.activeLangCode : state.activeLangCodeOfPages
            }
        case FETCHED_DIRECTORY_COMPANIES:
            return {
                ...state,
                isFetching: false,
                isResultFetched: true,
                searchParameter: "",
                directoryCompanies: state.currentPage === 0 ? action.directoryCompanies.data.map(x => ({ ...x, isMatchSearch: true })) : [...state.directoryCompanies, ...action.directoryCompanies.data.map(x => ({ ...x, isMatchSearch: true }))],
                count: action.directoryCompanies.paging.count,
            }
        case SEARCH_DIRECTORY_COMPANIES:
            return {
                ...state,
                searchParameter: action.searchParameter
            }
        case SELECT_DIRECTORY_COMPANY:
            return {
                ...state,
                directoryCompanies: state.directoryCompanies.map((company) => {
                    if (company.id === action.directoryCompanyId) {
                        return { ...company, selected: true }
                    } else {
                        return { ...company, selected: false }
                    }
                }),
                selectedCompanyDetails: null
            }
        case ANYWHERE_PARAM_COMPANY:
            return {
                ...state,
                searchAnywhereParam: action.searchAnywhereParam
            }
        case START_WITH_PARAM:
            return {
                ...state,
                startWithParam: action.startWithParam
            }
        case FETCH_DETAILS_FOR_SELECTED_COMPANY:
            return {
                ...state,
                isFetchingCompanyDetails: true,
                selectedCompanyDetails: null
            }
        case FETCHED_DETAILS_FOR_SELECTED_COMPANY:
            return {
                ...state,
                isFetchingCompanyDetails: false,
                selectedCompanyDetails: action.companyDetails
            }
        default:
            return state;
    }
}

export default directorySearchDataReducer;


// WEBPACK FOOTER //
// ./src/features/modules/directory-of-manufactory/directory-search-data/DirectorySearchDataReducer.js